import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Icon imports
import { CiCalendar } from "react-icons/ci";
import { IoMdCheckmark } from "react-icons/io";
import { MdOutlineCalendarToday } from "react-icons/md";
import { SlLocationPin } from "react-icons/sl";

// Asset imports
import Avatars from "../../assets/images/avatars.png";
import EventButton from "./EventButton";

function EventsCards({ data, hosted = false }) {

  const darktheme = useSelector((state) => state.features.settings.darktheme);


  const navigate = useNavigate();

  // Navigate to event details page
  const viewEvents = () => {
    navigate(`/dashboard/events/info/${data?.id}`);
  };

  // Truncate address text to prevent overflow
  const truncateAddress = (address, maxLength = 28) => {
    if (!address || address.length <= maxLength) return address;
    return `${address.slice(0, maxLength)}...`;
  };


  // Format attendee count text
  const getAttendeeText = (count) => {
    if (!count) return "0 People Interested";
    return `${count} ${count === 1 ? "Person" : "People"} Interested`;
  };

  // Render the appropriate button based on interest status and hosting
  const renderActionButton = () => {

    if (data?.interested) {
      if (hosted) {
        // Show attendee count for hosted events
        return (
          <EventButton
            className={`text-base text-[#525866] border-[1px] border-[#e2e4e9]`}
            imgSrc={Avatars}
            buttonText={getAttendeeText(data?.interestedAttendeesCount)}
          />
        );
      } else {
        // Show "Interested" status for non-hosted events
        return (
          <EventButton
            className={`text-base ${darktheme ? "text-[#FAFAFA]" : "text-[#525866]"} text-[#525866] border-[1px] border-[#e2e4e9]`}
            icon={<IoMdCheckmark className="w-[20px] h-[20px] font-[700]" />}
            buttonText={"Interested"}
          />
        );
      }
    } else {
      // Show "Interested?" CTA for non-interested events
      return (
        <EventButton
          className={` text-[#FDFDFE] button-black-gradient`}
          icon={<MdOutlineCalendarToday className="w-[20px] h-[20px] font-[700] text-[#FDFDFE]" />}
          buttonText={"Interested?"}
        />
      );
    }
  };

  // Handle missing or empty pictures array
  const getEventImage = () => {
    return data?.pictures?.[0] || "/placeholder-image.jpg";
  };

  return (
    <div
      onClick={viewEvents}
      className={`w-[258px] 2xl:w-[23.5%] cursor-pointer h-[288px] border-[1px] border-[#E2E4E9] p-[8px] rounded-[16px] hover:shadow-xl transition-shadow duration-200 shadow-lg`}
    >
      {/* Event Image */}
      <div className="h-[140px] rounded-[8px] bg-black overflow-hidden">
        <img
          src={getEventImage()}
          className="w-full h-full object-cover rounded-[8px]"
          alt={data?.title || "Event image"}
          onError={(e) => {
            e.target.src = "/placeholder-image.jpg"; // Fallback for broken images
          }}
        />
      </div>

      {/* Event Details */}
      <div className="flex-col -mt-1">
        {/* Event Title */}
        <h4 className={`font-[700] mt-[12px] mb-[4px] text-[16px] ${darktheme ? "text-[#fafafa]" : "text-[#1c2024]"} line-clamp-2`}>
          {data?.title || "Untitled Event"}
        </h4>

        {/* Date and Time */}
        <div className="flex mb-[4px] items-center">
          <CiCalendar className={`w-[20px] h-[20px] ${darktheme ? "text-[fafafa]" : "text-[#1c2024]"} flex-shrink-0`} />
          <p className={`${darktheme ? "text-[#fafafa]" : "text-[#60646C]"}  font-[400] text-[12px] ml-1`}>
            {data?.date && data?.time ? `${data.date} – ${data.time}` : "Date TBD"}
          </p>
        </div>

        {/* Location */}
        <div className="flex gap-[4px] items-center">
          <SlLocationPin className={`w-[20px] h-[20px] ${darktheme ? "text-[fafafa]" : "text-[#1c2024]"} flex-shrink-0 mt-[1px]`} />
          <p className={`${darktheme ? "text-[#fafafa]" : "text-[#60646C]"}  font-[400] text-[12px] ml-1`}>
            {truncateAddress(data?.address) || "Location TBD"}
          </p>
        </div>
      </div>

      {/* Action Button */}
      {renderActionButton()}
    </div>
  );
}

export default EventsCards;